// Module
var code = "<template><div class=\"row\" repeat.for=\"item of entityTypes\"><p class=\"col l8 m8 s8\">${item.type}</p><div class=\"switch col l4 m4 s4\"><label>Off <input type=\"checkbox\" checked.bind=\"item.isVisible\"> <span class=\"lever\"></span> On</label></div></div></template>";
// Exports
module.exports = code;